import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import StackView from '../StackView';
import { useHover } from '../hooks';

function Tab(props) {
  var axis = props.axis,
      children = props.children,
      disabled = props.disabled,
      id = props.id,
      isActive = props.isActive,
      restProps = _objectWithoutPropertiesLoose(props, ["axis", "children", "disabled", "id", "isActive"]);

  var _useHover = useHover(),
      hover = _useHover.hover,
      hoverProps = _useHover.hoverProps;

  var hovered = !disabled && hover;
  var borderSize = 2;
  var borderColor = isActive ? 'primary' : hovered ? 'separator' : 'separatorSecondary';

  if (axis === 'horizontal') {
    restProps.borderBottomWidth = borderSize;
    restProps.borderBottomColor = borderColor;
  } else {
    restProps.borderRightWidth = borderSize;
    restProps.borderRightColor = borderColor;
  }

  return /*#__PURE__*/React.createElement(StackView, _extends({
    id: id,
    role: "tab",
    "aria-selected": isActive,
    "aria-controls": id + "-panel",
    "aria-disabled": disabled,
    alignment: "center",
    distribution: "center",
    fontSize: 4,
    padding: 1,
    color: isActive || hovered ? 'foreground' : 'foregroundSecondary',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : undefined
  }, hoverProps, restProps), children);
}

export default Tab;